"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6577],{

/***/ 35934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "xv": function() { return /* binding */ Text; },
/* harmony export */   "zF": function() { return /* binding */ StyleableText; }
/* harmony export */ });
/* unused harmony export getDefaultProps */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86872);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60368);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






var BaseText = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.styled)(_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.Text, {
    name: "BaseText",
    fontFamily: "$body",
    color: "$contentPrimary",
    variants: {
        typography: {
            "...fontSize": function(fontSize) {
                return {
                    fontSize: fontSize,
                    fontWeight: fontSize,
                    letterSpacing: fontSize,
                    lineHeight: fontSize
                };
            }
        }
    }
}), isHeading = function(param) {
    var tag = param.tag, typography = param.typography;
    return tag ? [
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6"
    ].includes(tag) : !!typography && typography.startsWith("$header");
}, isParagraph = function(param) {
    var tag = param.tag, typography = param.typography;
    return tag ? tag === "p" : !!typography && typography.startsWith("$body");
}, getDefaultProps = function(props) {
    var defaultProps = {};
    return isHeading(props) && (defaultProps.accessibilityRole = "header"), isParagraph(props) && (defaultProps.userSelect = "auto"), _tamagui_core__WEBPACK_IMPORTED_MODULE_2__.isWeb && (defaultProps.display = isParagraph(props) || isHeading(props) ? "block" : "inline"), defaultProps;
}, Text = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(_param, ref) {
    var analyticsName = _param.analyticsName, _trackImpression = _param.trackImpression, trackImpression = _trackImpression === void 0 ? !1 : _trackImpression, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "analyticsName",
        "trackImpression"
    ]);
    var defaultProps = getDefaultProps(props), BaseTextWithProps = /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BaseText, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref
    }, defaultProps, props));
    return analyticsName && trackImpression ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_helpers_analytics__WEBPACK_IMPORTED_MODULE_5__/* .ComponentWithViewTracking */ .o, {
        Component: BaseTextWithProps,
        analyticsName: analyticsName,
        eventName: "textViewEvent",
        ref: ref
    }) : BaseTextWithProps;
}), StyleableText = BaseText.styleable(function(props, ref) {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BaseText, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        ref: ref
    }, props));
});



/***/ }),

/***/ 76614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35934);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Text = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Text__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref
    }, props));
});



/***/ }),

/***/ 20129:
/***/ (function(__unused_webpack_module, exports) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.T = void 0;
exports.T = {
    "accordion": {
        "typography": {
            "large": {
                "regular": "$bodyXlarge",
                "medium": "$labelXlarge"
            },
            "medium": {
                "regular": "$bodyLarge",
                "medium": "$labelLarge"
            },
            "small": {
                "regular": "$bodyMedium",
                "medium": "$labelMedium"
            },
            "xlarge": {
                "regular": "$subheaderXsmall",
                "medium": "$subheaderXsmall"
            },
            "eyebrow": {
                "default": "$labelXsmall"
            }
        },
        "color": {
            "content": {
                "valueText": "$contentPrimary",
                "eyebrow": "$contentTertiary",
                "state": {
                    "inactive": "$contentStateInactiveSecondary"
                }
            },
            "border": {
                "state": {
                    "focused": "$borderStateFocusedAccentBrand"
                },
                "default": "$borderPrimary"
            }
        },
        "padding": {
            "betweenTextChevron": {
                "default": "$2x"
            },
            "betweenEyebrowAndValueText": {
                "xlarge": "$5x",
                "large": "$4x",
                "medium": "$3x",
                "small": "$1x"
            },
            "betweenContentAndDivider": {
                "xlarge": "$11x",
                "large": "$11x",
                "medium": "$8x",
                "small": "$5x"
            }
        },
        "borderWidth": {
            "state": {
                "focused": "$default"
            },
            "default": "$default"
        },
        "fontWeight": {
            "valueTextOverride": "$regular",
            "eyebrowOverride": "$regular"
        },
        "size": {
            "height": {
                "xlarge": "$105x",
                "large": "$88x",
                "medium": "$72x",
                "small": "$56x"
            }
        },
        "animation": {
            "timing": {
                "openClose": "accelerateDecelerateFastest"
            }
        }
    },
    "button": {
        "borderWidth": {
            "default": "$default"
        },
        "cornerRadius": {
            "xsmall": "$6x",
            "small": "$7x",
            "medium": "$9x",
            "large": "$12x",
            "loadingAnimation": {
                "default": "$full"
            }
        },
        "computedValues": {
            "cornerRadius": {
                "state": {
                    "focus": {
                        "xsmall": "{button.corner-radius.xsmall} + {button.padding.border.focus} + {sem.radius.border-allowance}",
                        "small": "{button.corner-radius.small} + {button.padding.border.focus} + {sem.radius.border-allowance}",
                        "medium": "{button.corner-radius.medium} + {button.padding.border.focus} + {sem.radius.border-allowance}",
                        "large": "{button.corner-radius.large} + {button.padding.border.focus} + {sem.radius.border-allowance}"
                    }
                }
            },
            "opacity": {
                "loadingAnimation": {
                    "default": "0.4",
                    "inverse": "0.3"
                }
            },
            "size": {
                "maxWidth": {
                    "xsmall": {
                        "state": {
                            "focus": "{button.size.max-width.xsmall.state.default} + {sem.size.8x}"
                        }
                    }
                }
            }
        },
        "padding": {
            "leftRight": {
                "xsmall": "$8x",
                "small": "$10x",
                "medium": "$12x",
                "large": "$15x"
            },
            "topBottom": {
                "xsmall": "$6x",
                "small": "$9x",
                "medium": "$11x",
                "large": "$13x"
            },
            "border": {
                "focus": "$1x"
            },
            "loadingAnimation": {
                "xsmall": "$1x",
                "small": "$2x",
                "medium": "$2x",
                "large": "$2x"
            }
        },
        "typography": {
            "xsmall": "$labelMedium",
            "small": "$labelMedium",
            "medium": "$labelLarge",
            "large": "$labelXlarge"
        },
        "color": {
            "background": {
                "primary": "$backgroundAccentBrand",
                "secondaryInverse": "$backgroundInversePrimary",
                "secondary": "$backgroundPrimary",
                "state": {
                    "hover": {
                        "primary": "$backgroundStateHoverAccentBrand",
                        "secondaryInverse": "$backgroundInverseStateHoverSecondary",
                        "secondary": "$backgroundStateHoverPrimary"
                    },
                    "inactive": {
                        "primary": "$backgroundStateInactiveAccentBrand",
                        "secondaryInverse": "$backgroundInverseStateInactivePrimary",
                        "secondary": "$backgroundStateInactivePrimary"
                    }
                }
            },
            "content": {
                "primary": "$contentInversePrimary",
                "secondaryInverse": "$contentInversePrimary",
                "secondary": "$contentPrimary",
                "state": {
                    "inactive": {
                        "primary": "$contentInverseStateInactivePrimary",
                        "secondary": "$contentStateInactiveSecondary",
                        "secondaryInverse": "$contentInverseStateInactivePrimary"
                    }
                }
            },
            "border": {
                "primary": "$borderAccentBrand",
                "secondaryInverse": "$borderInversePrimary",
                "secondary": "$borderPrimary",
                "state": {
                    "focused": {
                        "primary": "$borderStateFocusedAccentBrand",
                        "secondaryInverse": "$borderStateFocusedSecondary",
                        "secondary": "$borderStateFocusedSecondary"
                    },
                    "hover": {
                        "primary": "$borderStateHoverAccentBrand",
                        "secondaryInverse": "$borderInverseStateHoverSecondary",
                        "secondary": "$borderStateHoverSecondary"
                    },
                    "inactive": {
                        "primary": "$borderStateInactiveAccentBrand",
                        "secondaryInverse": "$borderInverseStateInactivePrimary",
                        "secondary": "$borderStateInactiveSecondary"
                    }
                }
            }
        },
        "state": {
            "pressedScale": "$pressedScale"
        },
        "size": {
            "loadingAnimation": {
                "xsmall": "$4x",
                "small": "$5x",
                "medium": "$6x",
                "large": "$7x"
            },
            "maxWidth": {
                "xsmall": {
                    "state": {
                        "default": "$130x"
                    }
                }
            },
            "height": {
                "large": "$75x",
                "medium": "$65x",
                "small": "$55x"
            }
        },
        "outlineWidth": {
            "state": {
                "focus": {
                    "default": "$default"
                }
            }
        }
    },
    "cardCarousel": {
        "space": {
            "betweenTitleAndChevron": "$8x",
            "betweenTitleAndSubtitle": {
                "large": "$4x",
                "medium": "$2x"
            },
            "betweenCards": {
                "large": "$8x",
                "medium": "$8x",
                "small": "$8x"
            },
            "betweenTitleAndCards": {
                "large": "$16x",
                "medium": "$12x"
            },
            "betweenChevrons": {
                "large": "$12x",
                "medium": "$8x"
            }
        },
        "typography": {
            "title": {
                "large": "$headerMedium",
                "medium": "$subheaderMedium",
                "small": "$subheaderMedium"
            },
            "subhead": {
                "large": "$bodyLarge",
                "medium": "$bodyMedium",
                "small": "$bodySmall"
            }
        },
        "color": {
            "content": {
                "title": "$contentPrimary",
                "subhead": "$contentTertiary"
            }
        },
        "size": {
            "maxWidth": {
                "large": "$900x",
                "medium": "$847x",
                "small": "$450x",
                "cardContent": {
                    "small": "$345x"
                }
            },
            "minWidth": {
                "large": "$848x",
                "medium": "$451x",
                "small": "$320x"
            }
        },
        "margin": {
            "small": "$12x"
        },
        "state": {
            "scrolledCardScale": "$pressedScale"
        },
        "animation": {
            "timing": {
                "small": {
                    "ondrag": "decelerateFast"
                },
                "largeMedium": {
                    "onpress": "decelerateFast"
                }
            }
        }
    },
    "card": {
        "color": {
            "content": {
                "text": {
                    "default": "$contentPrimary",
                    "inactive": "$contentStateInactiveSecondary",
                    "accentTitle": "$contentTertiary"
                }
            },
            "background": {
                "faqCards": {
                    "default": "$backgroundTertiary",
                    "state": {
                        "hover": "$backgroundStateHoverSecondary",
                        "inactive": "$backgroundStateInactiveTertiary"
                    }
                }
            }
        },
        "typography": {
            "faqCard": {
                "title": "$subheaderXsmall",
                "eyebrow": "$bodySmall"
            },
            "articleCard": {
                "title": {
                    "large": "$headerLarge",
                    "medium": "$headerSmall"
                }
            }
        },
        "padding": {
            "faqCards": {
                "default": "$12x"
            },
            "articleCard": {
                "default": "$4x",
                "leftColumn": {
                    "large": "$20x",
                    "medium": "$15x"
                }
            }
        },
        "state": {
            "pressedScale": "$pressedScaleLargerObjects"
        },
        "gap": {
            "faqCard": {
                "default": "$8x",
                "betweenCards": "$8x"
            },
            "articleCard": {
                "buttons": "$6x",
                "betweenTextAndCta": {
                    "large": "$24x",
                    "medium": "$20x",
                    "small": "$12x"
                }
            }
        }
    },
    "cards": {
        "cornerRadius": {
            "faqCards": {
                "default": "$12x"
            },
            "articleCard": {
                "default": "$12x"
            }
        }
    },
    "dialog": {
        "color": {
            "scrimInverse": "$scrimLight",
            "background": {
                "default": "$backgroundPrimary",
                "mobile": {
                    "handle": "$backgroundPrimary",
                    "handleInverse": "$backgroundInverseStateInactiveSecondary"
                }
            },
            "scrim": "$scrimDark",
            "content": {
                "default": "$contentPrimary"
            }
        },
        "backgroundBlur": {
            "default": "$8x"
        },
        "padding": {
            "actions": {
                "closeIconButton": {
                    "desktop": "$12x"
                },
                "default": "$4x"
            },
            "titleAndDescription": {
                "desktop": "$12x",
                "mobile": "$8x"
            },
            "mobile": {
                "betweenElements": "$12x"
            }
        },
        "margin": {
            "desktop": {
                "top": "$24x",
                "leftRight": "$24x",
                "bottom": "$24x",
                "titleRight": "$16x"
            },
            "mobile": {
                "top": "$16x",
                "bottom": "$20x",
                "leftRight": "$16x",
                "acknowledgement": {
                    "leftRight": "$16x"
                },
                "handle": {
                    "bottom": "$4x"
                }
            }
        },
        "cornerRadius": {
            "scrollBar": "$full",
            "mobile": {
                "default": "$16x",
                "handle": "$full"
            },
            "desktop": {
                "default": "$16x"
            }
        },
        "percentage": {
            "maxWidth": "$6500x",
            "maxHeight": "$9000x",
            "minHeightWidth": "$1000x"
        },
        "opacity": {
            "mobileHandle": "$scrim"
        },
        "mobile": {
            "handle": {
                "height": "$8x",
                "width": "$88x"
            }
        },
        "typography": {
            "title": {
                "medium": "$headerLarge",
                "small": "$subheaderLarge"
            },
            "description": {
                "medium": "$bodyMedium",
                "small": "$bodySmall"
            }
        },
        "animation": {
            "enter": {
                "desktop": {
                    "timing": {
                        "scrim": "linear",
                        "dialog": "decelerateFast"
                    },
                    "scrimOpacity": {
                        "start": "$stateInvisible",
                        "end": "$stateSelected"
                    },
                    "delay": {
                        "afterScrimBeforeDialog": "$delayLeastDelay"
                    },
                    "percentage": {
                        "start": "$5000x",
                        "end": "$10000x"
                    },
                    "dialog": {
                        "start": "$stateInvisible",
                        "end": "$stateSelected"
                    }
                },
                "mobile": {
                    "scrimOpacity": {
                        "start": "$stateInvisible",
                        "end": "$stateSelected"
                    },
                    "timing": {
                        "scrim": "linear",
                        "dialog": "$durationShorter"
                    },
                    "delay": {
                        "afterScrimBeforeDialog": "$delayLeastDelay"
                    },
                    "dialog": {
                        "start": "$stateInvisible",
                        "end": "$stateSelected"
                    },
                    "curve": {
                        "dialog": "$curveDecelerate"
                    }
                }
            },
            "exit": {
                "desktop": {
                    "percentage": {
                        "start": "$10000x",
                        "end": "$5000x"
                    },
                    "dialog": {
                        "start": "$stateSelected",
                        "end": "$stateInvisible"
                    },
                    "timing": {
                        "dialog": "$durationShorter",
                        "scrim": "linear"
                    },
                    "curve": {
                        "dialog": "$curveDecelerate"
                    },
                    "scrimOpacity": {
                        "start": "$stateSelected",
                        "end": "$stateInvisible"
                    }
                },
                "mobile": {
                    "dialog": {
                        "start": "$stateSelected",
                        "end": "$stateInvisible"
                    },
                    "curve": {
                        "dialog": "$durationShortest"
                    },
                    "timing": {
                        "dialog": "$curveDecelerate",
                        "scrim": "linear"
                    },
                    "scrimOpacity": {
                        "start": "$stateSelected",
                        "end": "$stateInvisible"
                    }
                }
            }
        }
    },
    "formLayout": {
        "typography": {
            "nav": {
                "top": {
                    "address": "$labelMedium"
                }
            },
            "legalText": "$bodyXsmall",
            "singleQuestion": {
                "title": {
                    "largeMediumViewports": "$headerLarge",
                    "smallViewport": "$headerSmall"
                },
                "supportText": {
                    "largeMediumViewports": "$bodyLarge",
                    "smallViewport": "$bodyMedium"
                },
                "requirement": {
                    "largeMediumViewport": "$labelLarge",
                    "smallXsmallViewport": "$labelMedium"
                }
            }
        },
        "color": {
            "content": {
                "nav": {
                    "top": {
                        "addressLabel": "$contentPrimary"
                    }
                },
                "singleQuestion": {
                    "title": "$contentPrimary",
                    "supportText": "$contentTertiary"
                },
                "legalText": {
                    "default": "$contentPrimary"
                }
            },
            "background": {
                "nav": {
                    "default": "$backgroundPrimary"
                },
                "layout": {
                    "default": "$backgroundPrimary"
                },
                "page": {
                    "default": "$backgroundPrimary"
                }
            },
            "border": {
                "progressbar": {
                    "incomplete": "$borderPrimary",
                    "completed": "$borderStateFocusedAccentBrand"
                }
            },
            "scrim": "$scrimGradient180degInverse"
        },
        "margin": {
            "nav": {
                "top": {
                    "rightLeft": {
                        "xlargeviewport": "$28x",
                        "largeviewport": "$28x",
                        "mediumviewport": "$16x",
                        "smallviewport": "$12x",
                        "xsmallviewport": "$12x"
                    },
                    "topBottom": {
                        "xlargeviewport": "$10x",
                        "largeviewport": "$10x",
                        "mediumviewport": "$10x",
                        "smallviewport": "$9x",
                        "xsmallviewport": "$9x"
                    }
                },
                "bottom": {
                    "topBottom": {
                        "default": "$5x"
                    },
                    "rightLeft": {
                        "xlargeviewport": "$28x",
                        "largeviewport": "$28x",
                        "mediumviewport": "$16x",
                        "smallviewport": "$12x",
                        "xsmallviewport": "$12x"
                    }
                }
            },
            "contentContainer": {
                "leftRight": {
                    "largeviewport": "$28x",
                    "mediumviewport": "$16x",
                    "smallviewport": "$12x",
                    "xsmallviewport": "$12x"
                },
                "top": {
                    "largeviewport": "$28x",
                    "mediumviewport": "$24x",
                    "smallviewport": "$20x",
                    "xsmallviewport": "$14x"
                },
                "mobileBetweenContainers": "$20x",
                "gap": {
                    "xlargeviewport": "$28x",
                    "largeviewport": "$28x",
                    "mediumviewport": "$20x"
                }
            }
        },
        "maxWidth": {
            "xsmallviewport": "$374x",
            "smallviewport": "$767x",
            "mediumviewport": "$1200x"
        },
        "borderWidth": {
            "progressbar": {
                "default": "$object"
            }
        },
        "nav": {
            "bottom": {
                "scrim": {
                    "height": "$88x"
                }
            }
        },
        "padding": {
            "nav": {
                "bottom": {
                    "buttons": "$6x"
                }
            },
            "legal": "$1x",
            "questions": {
                "titleText": {
                    "largeMediumViewport": "$12x",
                    "smallViewport": "$8x"
                },
                "betweenContent": {
                    "xlargeviewport": "$40x",
                    "largeviewport": "$40x",
                    "mediumviewport": "$32x",
                    "smallviewport": "$24x",
                    "xsmallviewport": "$20x"
                },
                "betweenOtherAndTextinput": {
                    "large": "$20x",
                    "medium": "$16x",
                    "small": "$12x",
                    "xsmall": "$10x"
                },
                "subheadRequired": "$4x"
            }
        },
        "minWidth": {
            "xsmallviewport": "$320x",
            "smallviewport": "$375x",
            "mediumviewport": "$768x",
            "largeviewport": "$1201x",
            "xlargeviewport": "$1400x"
        },
        "animation": {
            "enterTransition": {
                "delay": {
                    "default": "$delayMoreDelay"
                },
                "timing": "$curveAccelerate"
            },
            "exitTransition": {
                "timing": "$curveDecelerate"
            }
        },
        "computedValues": {
            "animation": {
                "enterTransition": {
                    "duration": "{base.animation.duration.800ms}"
                },
                "exitTransition": {
                    "duration": "{base.animation.duration.1500ms}"
                }
            }
        },
        "opacity": {
            "animation": {
                "start": "$stateInvisible",
                "end": "$stateSelected"
            }
        },
        "progressBar": {
            "height": "$4x"
        }
    },
    "iconButton": {
        "color": {
            "icon": {
                "content": {
                    "default": "$contentPrimary",
                    "inverse": "$contentInversePrimary",
                    "state": {
                        "inactive": {
                            "default": "$contentStateInactiveSecondary"
                        }
                    },
                    "favorite": "$backgroundStateErrorPrimary"
                },
                "background": {
                    "default": "$backgroundPrimary",
                    "inverse": "$backgroundInversePrimary",
                    "state": {
                        "hover": {
                            "default": "$backgroundStateHoverPrimary",
                            "inverse": "$backgroundInverseStateHoverSecondary"
                        },
                        "inactive": {
                            "default": "$backgroundStateHoverPrimary",
                            "inverse": "$backgroundInverseStateInactiveTertiary"
                        }
                    }
                },
                "border": {
                    "default": "$borderTertiary",
                    "inverse": "$backgroundInversePrimary",
                    "state": {
                        "focused": {
                            "default": "$borderStateFocusedAccentBrand"
                        },
                        "hover": {
                            "inverse": "$borderInverseStateHoverSecondary",
                            "default": "$borderStateHoverTertiary"
                        },
                        "inactive": {
                            "inverse": "$borderInverseStateInactiveTertiary",
                            "default": "$borderStateInactiveTertiary"
                        }
                    }
                }
            }
        },
        "cornerRadius": {
            "default": "$full"
        },
        "borderWidth": {
            "default": "$default"
        },
        "state": {
            "pressedScale": "$pressedScale"
        },
        "size": {
            "small": "$24x",
            "medium": "$28x",
            "large": "$36x",
            "homeMarker": {
                "width": "$24x",
                "height": "$30x"
            }
        }
    },
    "image": {
        "radius": {
            "imageCornerRadius": {
                "2x": "$2x",
                "6x": "$6x",
                "8x": "$8x",
                "9x": "$9x",
                "10x": "$10x",
                "12x": "$12x",
                "16x": "$16x",
                "full": "$full"
            },
            "carouselDots": "$full"
        },
        "size": {
            "carouselDots": {
                "active": {
                    "width": "$16x",
                    "height": "$4x"
                },
                "other": "$4x"
            }
        },
        "color": {
            "background": {
                "carouselDots": "$backgroundPrimary"
            }
        },
        "opacity": {
            "carouselDots": {
                "other": "$stateUnselected"
            }
        },
        "space": {
            "carouselDots": {
                "betweenDots": "$4x",
                "belowDots": "$12x"
            }
        }
    },
    "link": {
        "typography": {
            "xlarge": "$bodyXlarge",
            "large": "$bodyLarge",
            "medium": "$bodyMedium",
            "small": "$bodySmall",
            "xsmall": "$bodyXsmall"
        },
        "textDecoration": {
            "default": "$link"
        },
        "color": {
            "content": {
                "secondary": "$contentPrimary",
                "primary": "$contentAccentBrand",
                "tertiary": "$contentTertiary",
                "secondaryInverse": "$contentInversePrimary",
                "state": {
                    "hover": {
                        "secondaryInverse": "$contentInverseStateInactiveTertiary",
                        "primary": "$contentStateHoverAccentBrand",
                        "secondary": "$contentStateHoverAccentBrand",
                        "tertiary": "$contentStateHoverAccentBrand"
                    },
                    "inactive": {
                        "secondaryInverse": "$contentInverseStateInactiveTertiary",
                        "primary": "$contentStateInactiveAccentBrand",
                        "secondary": "$contentStateInactiveSecondary",
                        "tertiary": "$contentStateInactiveSecondary"
                    }
                }
            },
            "border": {
                "state": {
                    "default": "$borderStateFocusedAccentBrand",
                    "inverse": "$borderInverseStateFocusedDefault"
                }
            }
        },
        "borderWidth": {
            "state": {
                "default": "$default"
            }
        },
        "padding": {
            "state": {
                "focused": {
                    "default": "$1x"
                }
            }
        },
        "cornerRadius": {
            "state": {
                "focused": "$2x"
            }
        },
        "fontWeight": {
            "medium": "$medium"
        }
    },
    "list": {
        "color": {
            "content": {
                "icon": {
                    "black": "$contentInversePrimary",
                    "neutral": "$contentPrimary",
                    "white": "$contentPrimary"
                },
                "number": {
                    "black": "$contentInversePrimary",
                    "neutral": "$contentPrimary",
                    "white": "$contentPrimary"
                },
                "body": {
                    "default": "$contentPrimary"
                },
                "title": {
                    "default": "$contentPrimary"
                },
                "eyebrow": {
                    "default": "$contentTertiary"
                },
                "groupTitle": {
                    "default": "$contentPrimary"
                },
                "groupSubtitle": {
                    "default": "$contentTertiary"
                }
            },
            "background": {
                "blackItem": "$backgroundInversePrimary",
                "neutralItem": "$backgroundTertiary",
                "white": "$backgroundPrimary",
                "neutralContainer": "$backgroundTertiary"
            },
            "border": {
                "default": "$borderPrimary"
            }
        },
        "space": {
            "margin": {
                "icon": {
                    "large": "$4x",
                    "small": "$1x"
                },
                "listItem": {
                    "topBottom": {
                        "large": "$16x",
                        "medium": "$12x"
                    }
                },
                "neutralContained": {
                    "right": {
                        "large": "$12x",
                        "largeNoIcon": "$16x",
                        "small": "$8x",
                        "smallNoIcon": "$12x"
                    },
                    "left": {
                        "large": "$8x",
                        "largeNoIcon": "$16x",
                        "small": "$6x",
                        "smallNoIcon": "$12x"
                    },
                    "topBottom": {
                        "large": "$16x",
                        "small": "$12x"
                    }
                }
            },
            "gap": {
                "text": {
                    "large": "$4x",
                    "medium": "$3x"
                },
                "iconText": {
                    "large": "$9x",
                    "medium": "$7x"
                },
                "titleSubhead": {
                    "large": "$4x",
                    "small": "$2x"
                },
                "titleListItems": {
                    "large": "$12x",
                    "small": "$8x"
                },
                "groupNeutralContained": {
                    "large": "$9x",
                    "small": "$6x"
                }
            }
        },
        "cornerRadius": {
            "icon": {
                "large": "$4x",
                "small": "$3x"
            },
            "item": {
                "large": "$10x",
                "small": "$8x"
            }
        },
        "typography": {
            "number": {
                "large": "$subheaderXsmall",
                "medium": "$bodyMedium"
            },
            "title": {
                "large": "$subheaderSmall",
                "medium": "$labelXlarge"
            },
            "body": {
                "large": "$bodyLarge",
                "medium": "$bodyMedium"
            },
            "eyebrow": {
                "large": "$labelSmall",
                "mediumSmall": "$labelXsmall"
            },
            "groupTitle": {
                "large": "$headerSmall",
                "small": "$subheaderSmall"
            },
            "groupSubhead": {
                "large": "$bodyLarge",
                "small": "$bodyMedium"
            }
        },
        "borderWidth": {
            "default": "$default"
        }
    },
    "loaders": {
        "size": {
            "spinnerWithLogo": {
                "width": {
                    "large": "$250x",
                    "small": "$160x"
                },
                "height": {
                    "large": "$250x",
                    "small": "$160x"
                }
            },
            "spinnerNoLogo": {
                "width": {
                    "large": "$250x",
                    "small": "$160x"
                },
                "height": {
                    "large": "$250x",
                    "small": "$160x"
                }
            }
        },
        "space": {
            "spinnerWithLogo": {
                "margin": {
                    "large": "$62dot5x",
                    "small": "$40x"
                }
            },
            "spinnerNoLogo": {
                "margin": {
                    "large": "$62dot5x",
                    "small": "$40x"
                }
            }
        },
        "color": {
            "background": {
                "spinnerWithLogo": "$backgroundInversePureBlack"
            }
        }
    },
    "pill": {
        "typography": {
            "regularWeight": {
                "medium": "$bodyMedium",
                "small": "$bodySmall"
            },
            "mediumWeight": {
                "medium": "$labelMedium",
                "small": "$labelSmall"
            }
        },
        "color": {
            "content": {
                "label": {
                    "default": "$contentTertiary",
                    "inverse": "$contentInversePrimary",
                    "accentBrand": "$contentStateHoverAccentBrand"
                }
            },
            "background": {
                "default": "$backgroundPrimary",
                "black": "$backgroundInversePrimary",
                "accentBrand": "$borderInverseAccentBrand"
            },
            "border": {
                "default": "$borderPrimary",
                "inverse": "$borderInverseStateInactiveTertiary",
                "black": "$borderInversePrimary",
                "accentBrand": "$borderInverseAccentBrand"
            }
        },
        "opacity": {
            "backgroundInverse": "$stateInverseDisabled"
        },
        "borderWidth": {
            "default": "$thinnest"
        },
        "padding": {
            "medium": {
                "rightLeft": "$6x",
                "top": {
                    "regularWeight": "$1dot5x",
                    "mediumWeight": "$2dot5x"
                },
                "bottom": {
                    "regularWeight": "$2x",
                    "mediumWeight": "$3x"
                }
            },
            "small": {
                "rightLeft": "$4x",
                "topBottom": {
                    "regularWeight": "$0dot5x",
                    "mediumWeight": "$1x"
                }
            }
        },
        "cornerRadius": {
            "rounded": "$full",
            "medium": "$4x",
            "small": "$2x",
            "borderAllowance": {
                "inverse": {
                    "regularWeight": {
                        "mediumSize": "$includeBorderAllowance4x",
                        "smallSize": "$includeBorderAllowance2x"
                    },
                    "mediumWeight": {
                        "smallSize": "$includeBorderAllowance2x",
                        "mediumSize": "$includeBorderAllowance4x"
                    }
                }
            }
        },
        "size": {
            "height": {
                "regularWeight": {
                    "mediumSize": "$33x",
                    "smallSize": "$24x"
                },
                "mediumWeight": {
                    "smallSize": "$24x",
                    "mediumSize": "$33x"
                }
            }
        }
    },
    "radioCheckbox": {
        "borderWidth": {
            "default": "$default"
        },
        "cornerRadius": {
            "element": {
                "radio": {
                    "default": "$full"
                },
                "checkbox": {
                    "large": "$4x",
                    "medium": "$3x",
                    "smallXsmall": "$3x"
                }
            },
            "row": {
                "large": "$12x",
                "medium": "$12x",
                "small": "$10x",
                "xsmall": "$8x"
            }
        },
        "padding": {
            "leftRight": {
                "large": "$10x",
                "medium": "$11x",
                "small": "$6x"
            },
            "rowGap": {
                "large": "$5x",
                "medium": "$4x",
                "small": "$3x",
                "xsmall": "$1x"
            },
            "titleRowGap": {
                "large": "$8x",
                "medium": "$7x",
                "small": "$6x",
                "xsmall": "$6x"
            },
            "titleSupportText": {
                "default": "$1x"
            },
            "errorMessageGap": {
                "large": "$9x",
                "medium": "$8x",
                "small": "$8x",
                "xsmall": "$8x"
            },
            "textCheckboxGap": {
                "default": "$4x"
            },
            "simpleCheckbox": {
                "medium": "$8x",
                "small": "$5x"
            },
            "titleRequired": "$1x",
            "radioWithImage": {
                "betweenValueText": {
                    "large": "$2x",
                    "small": "$1x"
                },
                "betweenRadio": {
                    "large": "$8x",
                    "medium": "$6x",
                    "small": "$6x",
                    "xsmall": "$6x"
                }
            }
        },
        "color": {
            "border": {
                "element": {
                    "checkbox": {
                        "default": "$borderPrimary",
                        "state": {
                            "focused": "$borderStateFocusedAccentBrand",
                            "error": "$borderStateErrorDefault",
                            "selected": "$borderStateFocusedPrimary"
                        }
                    }
                },
                "row": {
                    "state": {
                        "focused": "$borderStateFocusedAccentBrand",
                        "inactive": "$borderStateInactiveSecondary",
                        "hover": "$borderStateHoverPrimary",
                        "selected": "$borderStateFocusedPrimary",
                        "error": "$borderStateErrorDefault"
                    },
                    "default": "$borderPrimary"
                }
            },
            "content": {
                "title": {
                    "default": "$contentPrimary",
                    "state": {
                        "error": "$contentStateErrorDefault",
                        "inactive": "$contentStateInactivePrimary"
                    }
                },
                "supportText": {
                    "default": "$contentTertiary",
                    "state": {
                        "error": "$contentStateErrorDefault",
                        "inactive": "$contentStateInactivePrimary"
                    }
                },
                "element": {
                    "checkIcon": {
                        "state": {
                            "inactive": "$contentStateInactiveSecondary"
                        },
                        "default": "$contentInversePrimary"
                    },
                    "radioIcon": {
                        "state": {
                            "inactive": "$contentInverseStateInactiveTertiary",
                            "error": "$contentStateErrorDefault"
                        },
                        "default": "$contentInversePrimary"
                    }
                },
                "valueTextRowTwo": {
                    "default": "$contentTertiary",
                    "state": {
                        "inactive": "$contentStateInactivePrimary",
                        "error": "$contentStateErrorDefault"
                    }
                },
                "valueText": {
                    "default": "$contentPrimary",
                    "state": {
                        "inactive": "$contentStateInactivePrimary",
                        "error": "$contentStateErrorDefault"
                    }
                },
                "errorMessage": {
                    "default": "$contentStateErrorDefault"
                }
            },
            "background": {
                "element": {
                    "checkboxRadio": {
                        "default": "$contentInversePrimary",
                        "state": {
                            "inactive": "$backgroundStateHoverPrimary",
                            "selected": "$backgroundInversePrimary",
                            "error": "$backgroundStateErrorPrimary"
                        }
                    },
                    "row": {
                        "state": {
                            "hover": "$backgroundStateHoverPrimary",
                            "selected": {
                                "inactive": "$backgroundStateInactiveTertiary",
                                "error": "$backgroundStateErrorSecondary"
                            }
                        }
                    }
                }
            }
        },
        "typography": {
            "valueText": {
                "large": "$bodyXlarge",
                "medium": "$labelLarge",
                "small": "$labelMedium",
                "xsmall": "$bodyMedium"
            },
            "valueTextSecondLine": {
                "large": "$bodySmall",
                "medium": "$labelSmall",
                "small": "$labelXsmall",
                "xsmall": "$bodyXsmall"
            },
            "title": {
                "large": "$labelXlarge",
                "medium": "$labelLarge",
                "small": "$labelMedium",
                "xsmall": "$labelMedium"
            },
            "supportText": {
                "default": "$bodySmall"
            },
            "errorMessage": {
                "default": "$bodySmall"
            },
            "simpleCheckbox": {
                "medium": "$bodyMedium",
                "small": "$bodySmall",
                "xsmall": "$bodyXsmall"
            },
            "rightAligned": {
                "large": "$labelXlarge",
                "medium": "$labelLarge",
                "small": "$labelMedium",
                "xsmall": "$labelMedium"
            }
        },
        "size": {
            "element": {
                "radio": {
                    "interior": {
                        "large": "$10x",
                        "medium": "$16x",
                        "small": "$10x"
                    },
                    "exterior": {
                        "large": "$32x",
                        "medium": "$26x",
                        "small": "$24x",
                        "xsmall": "$20x"
                    }
                }
            },
            "rowHeight": {
                "large": "$75x",
                "medium": "$65x",
                "small": "$55x",
                "xsmall": "$51x"
            },
            "radioWithImage": {
                "imageHeight": {
                    "large": "$160x",
                    "medium": "$130x",
                    "small": "$88x"
                }
            },
            "maxHeight": {
                "radioWithImage": {
                    "large": "$40x",
                    "medium": "$60x",
                    "small": "$45x",
                    "xsmall": "$60x"
                }
            }
        },
        "margin": {
            "simpleCheckbox": {
                "topBottom": {
                    "medium": "$6x",
                    "small": "$6x"
                }
            },
            "radioWithImage": {
                "large": {
                    "rightLeftBottom": "$11x",
                    "top": "$10x"
                },
                "small": {
                    "rightLeftBottom": "$8x",
                    "top": "$7x"
                },
                "xsmall": {
                    "rightLeftBottom": "$6x",
                    "top": "$5x"
                }
            }
        },
        "opacity": {
            "radioWithImage": {
                "state": {
                    "inactive": "$stateInverseDisabled"
                }
            }
        },
        "maxWidth": {
            "radioWithImageGroup": {
                "medium": "$548x",
                "small": "$719x",
                "xsmall": "$326x"
            }
        },
        "minWidth": {
            "radioWithImage": {
                "large": "$250x",
                "medium": "$200x",
                "small": "$157x",
                "xsmall": "$130x"
            },
            "radioWithImageGroup": {
                "large": "$516x",
                "medium": "$332x",
                "small": "$327x",
                "xsmall": "$272x"
            }
        },
        "fontWeight": {
            "override": {
                "medium": "$regular",
                "small": "$regular"
            }
        }
    },
    "searchableDropdown": {
        "typography": {
            "valueText": {
                "large": "$bodyXlarge",
                "medium": "$bodyLarge",
                "small": "$bodyMedium",
                "xsmall": "$bodyMedium"
            }
        },
        "height": {
            "row": {
                "large": "$78x",
                "medium": "$68x",
                "small": "$58x",
                "xsmall": "$43x"
            },
            "selected": {
                "large": "$36x",
                "medium": "$34x",
                "small": "$28x",
                "xsmall": "$24x"
            },
            "group": {
                "large": "$328x",
                "medium": "$284x",
                "small": "$240x",
                "xsmall": "$180x"
            }
        },
        "margin": {
            "row": {
                "large": "$11x",
                "medium": "$10x",
                "small": "$8x",
                "xsmall": "$5x"
            },
            "group": {
                "large": "$4x",
                "medium": "$3x",
                "small": "$2x",
                "xsmall": "$2x"
            },
            "selected": {
                "rightLeft": {
                    "large": "$4x",
                    "medium": "$3x",
                    "small": "$3x",
                    "xsmall": "$3x"
                },
                "topBottom": {
                    "large": "$3x",
                    "medium": "$2x",
                    "small": "$1x"
                }
            }
        },
        "computedValues": {
            "margin": {
                "selected": {
                    "topBottom": {
                        "xsmall": "0"
                    }
                }
            }
        },
        "color": {
            "background": {
                "row": {
                    "state": {
                        "default": "$backgroundPrimary",
                        "hover": "$backgroundStateHoverPrimary",
                        "selected": "$backgroundStateHoverPrimary",
                        "pressed": "$backgroundStateHoverTertiary"
                    }
                },
                "group": "$backgroundPrimary"
            },
            "content": {
                "state": {
                    "inactive": "$contentStateInactiveSecondary",
                    "error": "$contentStateErrorDefault"
                },
                "checkmarkIcon": "$contentPrimary",
                "rowText": "$contentPrimary"
            },
            "border": {
                "group": {
                    "default": "$borderStateFocusedAccentBrand"
                }
            }
        },
        "radius": {
            "row": {
                "large": "$8x",
                "medium": "$7x",
                "small": "$6x",
                "xsmall": "$4x"
            },
            "group": {
                "large": "$12x",
                "medium": "$10x",
                "small": "$8x",
                "xsmall": "$6x"
            },
            "selected": {
                "large": "$6x",
                "medium": "$4x",
                "small": "$3x",
                "xsmall": "$3x"
            }
        },
        "borderWidth": {
            "group": "$default"
        },
        "padding": {
            "betweenTextAndIcon": {
                "large": "$6x",
                "medium": "$6x",
                "small": "$5x",
                "xsmall": "$5x"
            },
            "selected": {
                "betweenTextClose": {
                    "large": "$4x",
                    "medium": "$4x",
                    "small": "$3x",
                    "xsmall": "$2x"
                },
                "rowGap": {
                    "large": "$4x",
                    "medium": "$3x",
                    "small": "$2x",
                    "xsmall": "$2x"
                },
                "gap": {
                    "large": "$6x",
                    "medium": "$5x",
                    "small": "$4x",
                    "xsmall": "$4x"
                }
            }
        }
    },
    "stickyActionBar": {
        "space": {
            "mobile": {
                "marginAroundBar": {
                    "rightLeftBottom": "$4x"
                }
            },
            "iconLeft": {
                "leftMargin": "$10x"
            },
            "aroundActions": "$2x",
            "navAction": {
                "rightLeft": "$4x",
                "topBottom": "$10x"
            }
        },
        "color": {
            "scrimBehindBar": "$scrimGradient180degInverse",
            "background": {
                "default": "$backgroundPrimary",
                "navAction": {
                    "selected": "$backgroundTertiary"
                }
            },
            "border": {
                "default": "$borderPrimary"
            },
            "content": {
                "navLabel": {
                    "unselected": "$contentTertiary",
                    "selected": "$contentPrimary"
                }
            }
        },
        "cornerRadius": {
            "default": "$10x",
            "navAction": {
                "selected": "$8x"
            }
        },
        "borderWidth": {
            "default": "$thinnest"
        },
        "typography": {
            "navLabel": "$labelMedium"
        }
    },
    "switch": {
        "size": {
            "onOff": {
                "widthHeight": {
                    "large": "$32x",
                    "medium": "$28x",
                    "small": "$24x"
                }
            },
            "container": {
                "width": {
                    "large": "$76x",
                    "medium": "$64x",
                    "small": "$56x"
                },
                "height": {
                    "large": "$38x",
                    "medium": "$32x",
                    "small": "$28x"
                }
            },
            "height": {
                "rowHeight": {
                    "xlarge": "$105x",
                    "large": "$76x",
                    "medium": "$67x",
                    "small": "$56x",
                    "xsmall": "$49x"
                }
            }
        },
        "cornerRadius": {
            "onOff": {
                "large": "$includeBorderAllowance4x",
                "medium": "$3x",
                "small": "$2x"
            },
            "container": {
                "large": "$6x",
                "medium": "$4x",
                "small": "$3x"
            }
        },
        "color": {
            "background": {
                "onOff": {
                    "default": "$backgroundPrimary"
                },
                "containerOn": {
                    "state": {
                        "active": "$backgroundInversePrimary",
                        "hover": "$backgroundInverseStateHoverSecondary",
                        "focused": "$backgroundStateInactiveAccentBrand",
                        "inactive": "$backgroundStateInactiveTertiary"
                    }
                },
                "containerOff": {
                    "state": {
                        "active": "$backgroundInverseStateHoverTertiary",
                        "hover": "$backgroundInverseStateInactiveSecondary",
                        "focused": "$backgroundStateInactiveAccentBrand",
                        "inactive": "$backgroundStateInactiveTertiary"
                    }
                }
            },
            "content": {
                "default": "$contentPrimary",
                "valueSecondLine": {
                    "default": "$contentTertiary"
                }
            },
            "border": {
                "divider": "$borderPrimary"
            }
        },
        "typography": {
            "large": {
                "medium": "$labelXlarge",
                "regular": "$bodyXlarge"
            },
            "medium": {
                "medium": "$labelMedium",
                "regular": "$bodyMedium"
            },
            "small": {
                "medium": "$labelMedium",
                "regular": "$bodyMedium"
            },
            "xlarge": {
                "medium": "$subheaderXsmall",
                "regular": "$subheaderXsmall"
            },
            "valueSecondLine": {
                "xlarge": "$bodyMedium",
                "large": "$bodySmall",
                "medium": "$bodyXsmall"
            }
        },
        "gap": {
            "betweenTextAndSwitch": {
                "xlarge": "$7x",
                "large": "$6x",
                "medium": "$5x",
                "small": "$4x"
            }
        },
        "borderWidth": {
            "rowDivider": "$default"
        },
        "fontWeight": {
            "xlargesizeRegularweight": "$regular"
        }
    },
    "textButton": {
        "typography": {
            "large": "$labelXlarge",
            "medium": "$labelLarge",
            "small": "$labelMedium",
            "xsmall": "$labelSmall"
        },
        "textDecoration": {
            "default": "$link"
        },
        "color": {
            "content": {
                "secondary": "$contentPrimary",
                "state": {
                    "hover": {
                        "secondary": "$contentStateHoverAccentBrand",
                        "tertiary": "$contentStateHoverAccentBrand",
                        "primary": "$contentStateHoverAccentBrand",
                        "secondaryInverse": "$contentInverseStateInactiveTertiary"
                    },
                    "inactive": {
                        "secondary": "$contentStateInactiveSecondary",
                        "tertiary": "$contentStateInactiveSecondary",
                        "primary": "$contentStateInactiveAccentBrand",
                        "secondaryInverse": "$contentInverseStateInactiveTertiary"
                    }
                },
                "primary": "$contentAccentBrand",
                "secondaryInverse": "$contentInversePrimary",
                "tertiary": "$contentTertiary"
            },
            "border": {
                "state": {
                    "default": "$borderStateFocusedAccentBrand",
                    "inverse": "$borderInverseStateFocusedDefault"
                }
            }
        },
        "borderWidth": {
            "state": {
                "default": "$default"
            }
        },
        "padding": {
            "state": {
                "focused": {
                    "default": "$1x"
                }
            },
            "labelIconGap": {
                "default": "$2x"
            }
        },
        "cornerRadius": {
            "state": {
                "focused": "$2x"
            }
        },
        "fontWeight": {
            "regular": "$regular"
        }
    },
    "textInput": {
        "cornerRadius": {
            "large": "$12x",
            "medium": "$9x",
            "small": "$7x",
            "xsmall": "$6x"
        },
        "padding": {
            "leftRight": {
                "large": "$10x",
                "medium": "$9x",
                "small": "$65tenthsX",
                "xsmall": "$5x"
            },
            "topBottom": {
                "large": "$12x",
                "medium": "$9x",
                "small": "$7x",
                "xsmall": "$4x"
            },
            "gap": {
                "textAndField": {
                    "large": "$8x",
                    "medium": "$7x",
                    "small": "$5x",
                    "xsmall": "$5x"
                },
                "titleAndSupport": {
                    "default": "$1x"
                },
                "prefixValueSuffix": {
                    "default": "$2x"
                },
                "textAndIcon": {
                    "default": "$2x"
                }
            }
        },
        "color": {
            "border": {
                "default": "$borderPrimary",
                "state": {
                    "hover": "$borderStateHoverPrimary",
                    "selected": "$borderStateSelectedPrimary",
                    "focused": "$borderAccentBrand",
                    "error": "$borderStateErrorDefault",
                    "inactive": "$borderStateInactivePrimary"
                }
            },
            "background": {
                "default": "$backgroundPrimary",
                "state": {
                    "inactive": "$backgroundStateInactiveSecondary"
                }
            },
            "content": {
                "fieldTitle": {
                    "default": "$contentPrimary",
                    "state": {
                        "inactive": "$contentStateInactivePrimary",
                        "error": "$contentStateErrorDefault"
                    }
                },
                "supportText": {
                    "default": "$contentTertiary",
                    "state": {
                        "inactive": "$contentStateInactivePrimary",
                        "error": "$contentStateErrorDefault"
                    }
                },
                "placeholderText": {
                    "default": "$contentStateInactivePrimary"
                },
                "valueText": {
                    "state": {
                        "error": "$contentStateErrorDefault",
                        "inactive": "$contentStateInactivePrimary",
                        "percentage": "$contentTertiary"
                    },
                    "default": "$contentPrimary"
                },
                "prefixSuffix": {
                    "state": {
                        "inactive": "$contentStateInactivePrimary",
                        "error": "$contentStateErrorDefault"
                    },
                    "default": "$contentPrimary"
                },
                "errorMessage": {
                    "default": "$contentStateErrorDefault"
                },
                "icon": {
                    "default": "$contentPrimary",
                    "state": {
                        "inactive": "$contentStateInactivePrimary",
                        "error": "$contentStateErrorDefault"
                    }
                }
            }
        },
        "text": {
            "row": {
                "multiline": {
                    "default": "$row3x"
                }
            }
        },
        "typography": {
            "valueText": {
                "xsmall": "$bodyMedium",
                "small": "$bodyMedium",
                "medium": "$bodyLarge",
                "large": "$bodyXlarge"
            },
            "errorText": {
                "default": "$bodySmall"
            },
            "fieldTitle": {
                "xsmall": "$labelMedium",
                "small": "$labelMedium",
                "medium": "$labelLarge",
                "large": "$labelXlarge"
            },
            "supportText": {
                "default": "$bodySmall"
            }
        },
        "borderWidth": {
            "default": "$default"
        },
        "opacity": {
            "allText": {
                "inactive": "$stateInverseDisabled"
            }
        },
        "size": {
            "height": {
                "large": "$75x",
                "medium": "$65x",
                "small": "$55x"
            }
        }
    },
    "toast": {
        "color": {
            "background": {
                "default": "$backgroundInversePrimary",
                "error": "$backgroundStateErrorPrimary",
                "success": "$backgroundStateSuccessDefault"
            },
            "border": {
                "closeButton": {
                    "state": {
                        "focused": "$borderTertiary"
                    }
                }
            },
            "content": {
                "closeButton": {
                    "state": {
                        "hover": "$contentStateInactiveSecondary"
                    }
                },
                "valueText": {
                    "default": "$contentInversePrimary"
                }
            }
        },
        "radius": {
            "size": {
                "sAndXs": "$10x",
                "m": "$10x",
                "lAndXl": "$10x"
            }
        },
        "gap": {
            "betweenTextAndClose": {
                "default": "$8x"
            }
        },
        "padding": {
            "leftRight": {
                "xsAndX": "$12x",
                "m": "$12x",
                "lAndXl": "$12x"
            },
            "topBottom": {
                "xsAndS": "$12x",
                "m": "$12x",
                "lAndXl": "$12x"
            }
        },
        "margin": {
            "topBottom": {
                "xsAndS": "$8x",
                "m": "$16x",
                "lAndXl": "$16x"
            },
            "leftRight": {
                "xsAndS": "$8x",
                "m": "$8x",
                "lAndXl": "$16x"
            }
        },
        "size": {
            "maxWidth": "$1440x"
        },
        "typography": {
            "valueText": "$bodyMedium"
        },
        "animation": {
            "opacity": {
                "enter": {
                    "start": "$stateInvisible",
                    "end": "$stateSelected"
                },
                "exit": {
                    "start": "$stateSelected",
                    "end": "$stateInvisible"
                }
            },
            "enterTransition": {
                "offset": {
                    "start": "$68x",
                    "end": "$0x"
                }
            },
            "exitTransition": {
                "start": "$0x",
                "end": "$68x"
            },
            "timing": {
                "default": "decelerateFast"
            }
        }
    },
    "toggle": {
        "color": {
            "background": {
                "element": {
                    "toggle": {
                        "default": "$backgroundPrimary",
                        "state": {
                            "hover": "$backgroundStateHoverSecondary",
                            "error": "$backgroundStateInactivePrimary",
                            "errorOn": "$backgroundStateErrorPrimary",
                            "inactiveOn": "$backgroundInverseStateInactivePrimary"
                        },
                        "on": "$backgroundInversePrimary",
                        "light": {
                            "state": {
                                "hover": "$backgroundStateHoverPrimary"
                            }
                        },
                        "dark": {
                            "state": {
                                "selected": "$backgroundInversePrimary",
                                "hover": "$backgroundStateHoverPrimary"
                            }
                        }
                    }
                }
            },
            "content": {
                "element": {
                    "toggle": {
                        "on": "$contentInversePrimary",
                        "off": "$contentPrimary",
                        "state": {
                            "error": "$contentStateErrorDefault",
                            "inactiveOn": "$contentInverseStateInactiveSecondary",
                            "inactiveOff": "$contentStateInactiveSecondary"
                        },
                        "label": {
                            "state": {
                                "unselected": "$contentTertiary",
                                "selected": "$contentPrimary",
                                "inverse": "$contentInversePrimary"
                            }
                        },
                        "icon": {
                            "state": {
                                "selected": "$contentPrimary",
                                "unselected": "$contentTertiary",
                                "inverse": "$contentInversePrimary"
                            }
                        }
                    }
                }
            },
            "border": {
                "element": {
                    "toggle": {
                        "state": {
                            "focused": "$borderStateFocusedAccentBrand",
                            "error": "$borderStateErrorDefault",
                            "selected": "$borderStateSelectedPrimary",
                            "unselected": "$borderTertiary",
                            "unselectedHover": "$borderStateHoverTertiary",
                            "default": "$borderPrimary"
                        }
                    }
                },
                "toggleGroup": "$borderPrimary"
            }
        },
        "cornerRadius": {
            "element": {
                "toggle": {
                    "large": "$9x",
                    "medium": "$9x",
                    "small": "$7x",
                    "bounded": {
                        "mediumSize": "$9x",
                        "smallSize": "$7x"
                    }
                }
            }
        },
        "borderWidth": {
            "element": {
                "state": {
                    "default": "$default"
                }
            }
        },
        "padding": {
            "textInput": {
                "valueAndToggle": {
                    "gap": "$8x"
                },
                "left": {
                    "large": "$10x",
                    "medium": "$9x",
                    "small": "$65tenthsX",
                    "xsmall": "$5x"
                },
                "right": {
                    "large": "$675tenthsX",
                    "medium": "$575tenthsX",
                    "small": "$475tenthsX",
                    "xsmall": "$1x"
                },
                "topBottom": {
                    "large": "$6x",
                    "medium": "$575tenthsX",
                    "small": "$475tenthsX",
                    "xsmall": "$1x"
                }
            },
            "element": {
                "textIcon": "$2x"
            }
        },
        "size": {
            "element": {
                "onOff": {
                    "large": "$44x",
                    "medium": "$38x",
                    "small": "$32x"
                },
                "background": {
                    "width": {
                        "large": "$88x",
                        "medium": "$76x",
                        "small": "$64x"
                    },
                    "height": {
                        "large": "$44x",
                        "medium": "$38x",
                        "small": "$32x"
                    }
                }
            },
            "height": {
                "large": "$75x"
            }
        },
        "animation": {
            "timing": {
                "onOff": {
                    "dollarPercentage": "accelerateDecelerateFastest"
                },
                "element": {
                    "lightAndDark": "accelerateDecelerateFastest"
                }
            }
        },
        "fontWeight": {
            "element": {
                "state": {
                    "unselected": "$regular"
                }
            }
        },
        "typography": {
            "element": {
                "mediumSize": "$labelMedium",
                "smallSize": "$labelSmall"
            }
        },
        "margin": {
            "element": {
                "mediumSize": "$9x",
                "smallSize": "$6x",
                "state": {
                    "unselected": {
                        "mediumSize": "$975tenthsX",
                        "smallSize": "$675tenthsX"
                    }
                }
            }
        }
    }
};


/***/ })

}]);